export default "__VITE_ASSET__Dq1eFF_m__"